var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _JoltClient_subscriptions, _JoltClient_logger, _JoltClient_retryTimeout, _JoltClient_fetchSubscribeToken;
import { JoltConnection, } from "./JoltConnection";
import { JoltSubscription, } from "./JoltSubscription";
import { Logger, NullLogger } from "./Logger";
const DEFAULT_RETRY_TIMEOUT = 3000;
const DEFAULT_RETRY_TIMEOUT_FN = (_previousTimeout, retryCount) => {
    return DEFAULT_RETRY_TIMEOUT * Math.pow(2, retryCount);
};
export class JoltClient {
    constructor(wssEndpoint, { fetchAuthTokenFn, fetchSubscribeTokenFn }, { logToConsole = false, pingInterval = 240000, pingTimeout = 2000, retryTimeout = DEFAULT_RETRY_TIMEOUT_FN, } = {}) {
        _JoltClient_subscriptions.set(this, void 0);
        _JoltClient_logger.set(this, void 0);
        _JoltClient_retryTimeout.set(this, void 0);
        _JoltClient_fetchSubscribeToken.set(this, void 0);
        __classPrivateFieldSet(this, _JoltClient_logger, logToConsole ? new Logger() : new NullLogger(), "f");
        this.connection = new JoltConnection(wssEndpoint, fetchAuthTokenFn, {
            logger: __classPrivateFieldGet(this, _JoltClient_logger, "f"),
            pingInterval,
            pingTimeout,
            retryTimeout,
        });
        __classPrivateFieldSet(this, _JoltClient_fetchSubscribeToken, fetchSubscribeTokenFn, "f");
        __classPrivateFieldSet(this, _JoltClient_retryTimeout, retryTimeout, "f");
        __classPrivateFieldSet(this, _JoltClient_subscriptions, [], "f");
    }
    subscribe(channelName, { fetchSubscribeTokenFn = __classPrivateFieldGet(this, _JoltClient_fetchSubscribeToken, "f"), ...rest } = {}) {
        if (!fetchSubscribeTokenFn)
            throw "Missing fetchSubscribeTokenFn";
        const subscription = new JoltSubscription(this.connection, channelName, fetchSubscribeTokenFn, {
            retryTimeout: __classPrivateFieldGet(this, _JoltClient_retryTimeout, "f"),
            logger: __classPrivateFieldGet(this, _JoltClient_logger, "f"),
            ...rest,
        });
        __classPrivateFieldGet(this, _JoltClient_subscriptions, "f").push(subscription);
        subscription.subscribe();
        return subscription;
    }
    unsubscribe(channelName) {
        __classPrivateFieldSet(this, _JoltClient_subscriptions, __classPrivateFieldGet(this, _JoltClient_subscriptions, "f").filter((subscription) => {
            if (subscription.channel === channelName) {
                subscription.unsubscribe();
                return false;
            }
            return true;
        }), "f");
    }
    disconnect() {
        this.connection.disconnect();
    }
    ping() {
        this.connection.ping();
    }
    get subscriptions() {
        return __classPrivateFieldGet(this, _JoltClient_subscriptions, "f").filter((s) => s.subscribed);
    }
    get allSubscriptions() {
        return __classPrivateFieldGet(this, _JoltClient_subscriptions, "f");
    }
}
_JoltClient_subscriptions = new WeakMap(), _JoltClient_logger = new WeakMap(), _JoltClient_retryTimeout = new WeakMap(), _JoltClient_fetchSubscribeToken = new WeakMap();
//# sourceMappingURL=JoltClient.js.map